<script setup lang="ts">
import { svgIcon } from "@/common/components";
</script>

<template>
	<div class="base-loading">
		<div class="icon animate spin">
			<svg-icon icon="loading" size="1.75rem" />
		</div>
	</div>
</template>

<style lang="scss" scoped>
.base-loading {
  display: flex;
  width: 100%;
  height: 2rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .icon {
    color: var(--primary);
  }
}
</style>